'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useCallback, useEffect, useRef, useState } from 'react';

/** Delay before auto-showing the NPS modal (ms) */
const AUTO_SHOW_DELAY = 3000;

/**
 * Manages NPS modal open/close UI state with an auto-show timer.
 *
 * All business logic (completed, dismissed, enabled) lives in each
 * app's `npsStore` — this hook is purely UI state.
 */
export function useNpsModal() {
  const [isOpen, setIsOpen] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const openModal = useCallback(() => {
    clearTimer();
    setIsOpen(true);
  }, [clearTimer]);

  const closeModal = useCallback(() => {
    clearTimer();
    setIsOpen(false);
  }, [clearTimer]);

  // Auto-show after a short delay so it doesn't flash on page load
  useEffect(() => {
    timerRef.current = setTimeout(openModal, AUTO_SHOW_DELAY);
    return () => clearTimer();
  }, [openModal, clearTimer]);

  return {
    isOpen,
    openModal,
    closeModal,
  };
}
